import React, { useEffect, useState } from 'react';
import { placeholderSvgDataUrl } from '../../utils/placeholderImage';

const ProductGallery = ({ product }) => {
  const images = Array.isArray(product.images) && product.images.length > 0
    ? product.images
    : [placeholderSvgDataUrl({ width: 800, height: 800, text: product.title || 'Product' })];

  const [activeImg, setActiveImg] = useState(images[0]);

  useEffect(() => {
    setActiveImg(images[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product?.id]);

  return (
    <div className="flex w-full flex-col gap-2 lg:gap-3">
      {/* Main image — big on desktop */}
      <div className="relative w-full overflow-hidden rounded-2xl border border-line bg-card shadow-2xl shadow-black/50">
        <div className="flex h-[280px] w-full items-center justify-center bg-card p-4 sm:h-[380px] lg:h-[600px]">
          <img
            key={activeImg}
            src={activeImg}
            alt={product.title}
            className="max-h-full max-w-full rounded-xl object-contain drop-shadow-lg animate-fade-in"
          />
        </div>
        {product.featured && (
          <span className="absolute left-3 top-3 rounded-full bg-brand px-3 py-1 text-xs font-bold text-black shadow-lg shadow-brand/30">
            ★ Bestseller
          </span>
        )}
      </div>

      {/* Thumbnails — grid on mobile, centered strip on desktop */}
      <div className="grid w-full grid-cols-5 gap-2 lg:flex lg:justify-center lg:gap-3">
        {images.slice(0, 7).map((src, i) => (
          <button
            key={i}
            onClick={() => setActiveImg(src)}
            className={`h-14 w-full shrink-0 overflow-hidden rounded-xl border-2 transition-all duration-200 hover:border-brand lg:h-[72px] lg:w-[72px] ${
              activeImg === src ? 'border-brand' : 'border-line bg-card'
            }`}
            aria-label={`Thumbnail ${i + 1}`}
          >
            <img src={src} alt="" className="h-full w-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;
